import * as React from 'react';
import { assertions } from 'lib/assertions';
import EventTracking from 'lib/EventTracking';
import Button from 'components/ButtonDeprecated';
import DividerText from 'components/DividerText';
import FormElement from 'components/FormElement';
import Input from 'components/Input';
// @ts-ignore
import GoogleSignIn from 'auth/components/GoogleSignIn';

import { CookieWarning } from './cookieUtils';

export type Props = {
  emailConfirmationToken?: string;
  initialUid?: string;
  onUidChange: (uid?: string) => void;
  onSubmit: () => void;
  submitIsDisabled: boolean;
};

const eventPrefix = 'sign_in.uid_page';

export default function EnterUid({
  emailConfirmationToken,
  initialUid,
  onUidChange,
  onSubmit,
  submitIsDisabled,
}: Props) {
  React.useEffect(() => {
    EventTracking.trackKey(`${eventPrefix}.view`);
  }, []);

  return (
    <React.Fragment>
      <form
        data-test="sign-in-uid-form"
        onSubmit={e => {
          e.preventDefault();
          onSubmit();
        }}>
        <CookieWarning />
        <FormElement
          data-test="uid-field"
          label="Email address or phone number"
          onValidChange={e => onUidChange(e.target.value)}
          onInvalidChange={() => onUidChange(undefined)}
          validate={e => {
            assertions.emailOrPlausibleNorthAmericanPhoneNumber(
              e.target.value,
              'Invalid phone number or email address. Please try again.'
            );
          }}
          element={Input}
          elementProps={{
            autocomplete: 'username',
            name: 'uid',
            type: 'username',
            placeholder: 'Email address or phone number',
            size: 'large',
            required: true,
            defaultValue: initialUid,
            onClick: () => {
              EventTracking.trackKey(`${eventPrefix}.enter_uid.click`);
            },
          }}
        />
        <Button
          data-test="uid-submit-button"
          eventKey={`${eventPrefix}.continue.click`}
          type="submit"
          level="primary"
          full
          disabled={submitIsDisabled}>
          Continue
        </Button>
      </form>

      <DividerText uppercase>or</DividerText>

      <GoogleSignIn
        mergeToken={emailConfirmationToken}
        eventKey={`${eventPrefix}.continue_with_google.click`}
        body="Continue with Google"
      />
    </React.Fragment>
  );
}
